import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	TextField,
	Typography,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../../features/authSlice'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { toastHelper } from '../../../util/toastHelper'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import Stepper from '../../atoms/Stepper/Stepper'
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { BUSINESS_PROFILE_TOTAL_STEPS } from '../../../util/constants'

const defaultCover =
	'https://static.vecteezy.com/system/resources/previews/021/686/124/large_2x/blue-background-high-resolution-wallpaper-free-free-photo.jpg'

export const SocialProfilesModal = ({step, formData, setFormData, setStep, onUpdateProfile, saving = false }) => {
	const dispatch = useDispatch()

	const validHost = (value, allowedHosts) => {
    const raw = (value || '').trim()
    if (!raw) return true 
    try {
      const u = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`)
      const host = u.hostname.toLowerCase()
      return allowedHosts.some((h) => host === h || host.endsWith(`.${h}`))
    } catch {
      return false
    }
  }

    const isValidUrl = (string) => {
        try {
            const url = new URL(string);
            return url.protocol === "http:" || url.protocol === "https:";
        } catch (error) {
            return false;
        }
    }

  const validateLinks = () => {
    const { instagramLink, tiktokLink, facebookLink, websiteLink } = formData
    if (!validHost(instagramLink, ['instagram.com'])) {
      toastHelper('Instagram link must be an instagram.com URL', 'error')
      return false
    }
    if (!validHost(tiktokLink, ['tiktok.com'])) {
      toastHelper('TikTok link must be a tiktok.com URL', 'error')
      return false
    }
    if (!validHost(facebookLink, ['facebook.com'])) {
      toastHelper('Facebook link must be a facebook.com URL', 'error')
      return false
    }
    if(websiteLink && !isValidUrl(websiteLink)){
      toastHelper('Invalid url', 'error')
      return false
    }
    return true
  }

	const textFieldStyles = {
		margin: '0',
		width: '100%',
		'.MuiInputBase-input': {
			padding: '10px 10px 10px 0',
			fontSize: '14px',
			fontWeight: '400',
			color: '#313131',
		},

		'& label.MuiInputLabel-root': {
			color: '#7ca6bd',
		},
		'& .MuiInputBase-input.Mui-disabled': {
			color: '#313131',
			WebkitTextFillColor: 'black',
			opacity: 1,
			padding: '10px 10px 10px 0',
			fontSize: '14px',
			fontWeight: '400',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
			bgcolor: 'white',
			'& > fieldset': {
				borderColor: '#DFE4EB !important',
			},
		},
	}

	const handleChange = (e, field) => {
		setFormData({ ...formData, [field]: e.target.value })
	}

	const handleComplete = () => {
		if (!validateLinks()) return
		onUpdateProfile(null, true) // true indicates this is the final step
	}

	return (
		<>
			<Grid size={{ xs: 12, sm: 6 }} className={Style.imageContainer}>
				<div className="imageContainer">
					<img src={defaultCover} alt="signup-img.jpg" />
				</div>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 6 }}
				className={Style.formContainer}
				sx={{
					height: 'auto',
					maxHeight: 'max-content',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						minHeight: '80%',
						height: '100%',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
						className={Style.titleContainer}
					>
						<Typography
							variant="h3"
							gutterBottom
							className={Style.title}
						>
							Link Social Profiles
						</Typography>
					</Box>
					<FormControl
						variant="standard"
						sx={{
							width: '100%',
							gap: '16px',
						}}
					>
						<Box>
							<InputLabel
								sx={{
									position: 'unset',
									font: 'var(--body-font-three)',
									color: 'var(--brand)',
									mb: '8px',
									transform: 'translate(0, 0) scale(1)',
								}}
							>
								Instagram
							</InputLabel>
							<TextField
								placeholder="https://www.instagram.com/handle"
								sx={textFieldStyles}
								value={formData.instagramLink}
								onChange={(e) =>
									handleChange(e, 'instagramLink')
								}
								slotProps={{
									input: {
										startAdornment: (
											<img
												src="/images/instagram.svg"
												alt="instagram"
												style={{
													width: '18px',
													marginRight: '4px',
												}}
											/>
										),
									},
								}}
							/>
						</Box>
						<Box>
							<InputLabel
								sx={{
									position: 'unset',
									font: 'var(--body-font-three)',
									color: 'var(--brand)',
									mb: '8px',
									transform: 'translate(0, 0) scale(1)',
								}}
							>
								Tiktok
							</InputLabel>
							<TextField
								// label="Tiktok"
								placeholder="https://www.tiktok.com/handle"
								sx={textFieldStyles}
								value={formData.tiktokLink}
								onChange={(e) => handleChange(e, 'tiktokLink')}
								slotProps={{
									input: {
										startAdornment: (
											<img
												src="/images/tiktok.svg"
												alt="tiktok"
												style={{
													width: '18px',
													marginRight: '4px',
												}}
											/>
										),
									},
								}}
							/>
						</Box>
						<Box>
							<InputLabel
								sx={{
									position: 'unset',
									font: 'var(--body-font-three)',
									color: 'var(--brand)',
									mb: '8px',
									transform: 'translate(0, 0) scale(1)',
								}}
							>
								Facebook
							</InputLabel>
							<TextField
								// label="Facebook"
								placeholder="https://www.facebook.com/handle"
								sx={textFieldStyles}
								value={formData.facebookLink}
								onChange={(e) =>
									handleChange(e, 'facebookLink')
								}
								slotProps={{
									input: {
										startAdornment: (
											<img
												src="/images/facebook.svg"
												alt="facebook"
												style={{
													width: '18px',
													marginRight: '4px',
												}}
											/>
										),
									},
								}}
							/>
						</Box>
						<Box>
							<InputLabel
								sx={{
									position: 'unset',
									font: 'var(--body-font-three)',
									color: 'var(--brand)',
									mb: '8px',
									transform: 'translate(0, 0) scale(1)',
								}}
							>
								Business Website
							</InputLabel>
							<TextField
								placeholder="https://www.yourBusinessWebsite"
								sx={textFieldStyles}
								value={formData.websiteLink}
								onChange={(e) =>
									handleChange(e, 'websiteLink')
								}
								slotProps={{
									input: {
										startAdornment: (
											<LanguageOutlinedIcon
												sx={{
													width: '18px',
													marginRight: '4px',
                                                    color: '#7ca6bd'
												}}
											/>
										),
									},
								}}
							/>
						</Box>
					</FormControl>
					<Box
						className={Style.buttonContainer}
						sx={{ justifyContent: 'space-between' }}
					>
						<ButtonCustom
							onClick={() => setStep((step) => step - 1)}
							className="backButton"
						>
							Previous
						</ButtonCustom>
						<ButtonCustom disabled={saving} onClick={handleComplete}>
							{saving ? 'Saving…' : 'Complete'}
						</ButtonCustom>
					</Box>
					<Box>
						<Stepper
							totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
							subSteps={1}
							activeStep={step}
						/>
					</Box>
				</Box>
			</Grid>
		</>
	)
}
